const activities = [
  {
    name: 'selectGoalObjective',
    value: 'selectGoalObjective',
  },
  {
    name: 'selectGoalType',
    value: 'selectGoalType',
  },
  {
    name: 'editGoalDetails',
    value: 'editGoalDetails',
  },
  {
    name: 'editGoalDetails.normalGoal',
    value: 'editGoalDetails.normalGoal',
  },
  {
    name: 'editGoalDetails.smartGoal',
    value: 'editGoalDetails.smartGoal',
  },
  {
    name: 'setupTag',
    value: 'setupTag',
  },
  {
    name: 'setupTag.selectTag',
    value: 'setupTag.selectTag',
  },
  {
    name: 'setupTag.noTag',
    value: 'setupTag.noTag',
  },
  {
    name: 'setupTag.noTag.selectTagMethod',
    value: 'setupTag.noTag.selectTagMethod',
  },
  {
    name: 'setupTag.noTag.installTag',
    value: 'setupTag.noTag.installTag',
  },
  {
    name: 'setupTag.noTag.emailTag',
    value: 'setupTag.noTag.emailTag',
  },
  {
    name: 'setupTag.noTag.platformTag',
    value: 'setupTag.noTag.platformTag',
  },
  {
    name: 'setupTag.noTag.platformTagInstructions',
    value: 'setupTag.noTag.platformTagInstructions',
  },
  {
    name: 'setupTag.noTag.gtmTag',
    value: 'setupTag.noTag.gtmTag',
  },
  {
    name: 'setupTag.addEventTag',
    value: 'setupTag.addEventTag',
  },
  {
    name: 'setupTag.eventTagChoice',
    value: 'setupTag.eventTagChoice',
  },
  {
    name: 'setupTag.addEventTagWithClarity',
    value: 'setupTag.addEventTagWithClarity',
  },
  {
    name: 'endFlow',
    value: 'endFlow',
  },
  {
    name: 'createWizard',
    value: 'createWizard',
  },
  {
    name: 'editGoalDetails.enhancedConversions',
    value: 'editGoalDetails.enhancedConversions',
  },
  {
    name: 'setupTag.setupEnhancedConv',
    value: 'setupTag.setupEnhancedConv',
  },
];

export const instrumentationSchema = {
  scenario: [
    // All activities must be under this scenario so that we can later use SceId to string together a session.
    {
      name: 'goalCreationWizard',
      value: 'goalCreationWizard',
      activity: activities,
    },
  ],
};
